import { CompetitorCircuitRole, CompetitorCircuitStatus, MissionAssignationStatus } from '../api/api.g';
import type { CompetitorCircuitDetailsResponse, GetSurveyFromMissionAssignationViewModel } from '../api/api.g';

export type CircuitSurveyContext = {
  circuitId: string;
  mainMissionAssignationId: string;
  role: CompetitorCircuitRole;
  visitName?: string;
};

export const getCircuitSurveyContext = (
  survey?: GetSurveyFromMissionAssignationViewModel,
): CircuitSurveyContext | undefined => survey?.competitorCircuitId && survey.competitorCircuitMainMissionAssignationId ? {
  circuitId: survey.competitorCircuitId,
  mainMissionAssignationId: survey.competitorCircuitMainMissionAssignationId,
  role: survey.competitorCircuitRole,
  visitName: survey.branchInfo?.name,
} : undefined;

export const isCircuitSurveyCorrection = (status?: MissionAssignationStatus) =>
  status === MissionAssignationStatus.ValidationRejected || status === MissionAssignationStatus.PrevalidationFailed;

export const requiresCircuitVisitConfirmation = (
  role: CompetitorCircuitRole,
  status?: MissionAssignationStatus,
  inProgress?: boolean,
) => role !== CompetitorCircuitRole.FollowUp && !isCircuitSurveyCorrection(status) && !inProgress;

export const getCircuitSubmissionState = (circuit?: CompetitorCircuitDetailsResponse) => {
  const steps = circuit?.steps ?? [];
  const visits = steps.filter(step => step.role !== CompetitorCircuitRole.FollowUp);
  const followUp = steps.find(step => step.role === CompetitorCircuitRole.FollowUp);
  return {
    approved: circuit?.status === CompetitorCircuitStatus.Completed,
    cancelled: circuit?.status === CompetitorCircuitStatus.Cancelled,
    allSubmitted: !!circuit?.totalSteps && (circuit.completedSteps ?? 0) >= circuit.totalSteps,
    comparisonAvailable: !!followUp && !followUp.submittedDateUtc && followUp.status === MissionAssignationStatus.Assigned,
    waitingForComparison: visits.length > 0 && visits.every(step => !!step.submittedDateUtc) && !followUp,
  };
};

export const circuitSurveyReturnMessage = (context: CircuitSurveyContext) => JSON.stringify({
  type: 'competitor-circuit-survey-completed',
  circuitId: context.circuitId,
  mainMissionAssignationId: context.mainMissionAssignationId,
});
